import styled, { css } from 'styled-components';

export const Container = styled.div(
  ({ theme }) => css`
    padding: ${theme.sz.s6};
    box-sizing: border-box;
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.s};
    margin: 0 0 ${theme.sz.s4} 0;
    color: ${theme.co.neutral10};
  `,
);

export const LearnableInfo = styled.div(
  ({ theme }) => css`
    background-color: ${theme.co.neutral95};
    border: 1px solid ${theme.co.neutral90};
    border-radius: ${theme.sz.s1};
    padding: ${theme.sz.s3};
    margin-bottom: ${theme.sz.s4};
  `,
);

export const LearnableLabel = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    font-weight: 600;
    color: ${theme.co.neutral30};
    margin-bottom: ${theme.sz.s1};
  `,
);

export const LearnableDisplay = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s1};
  `,
);

export const LearnablePart = styled.div<{ $isDefinition: boolean }>(
  ({ theme, $isDefinition }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.neutral10};
    opacity: ${$isDefinition ? 0.8 : 1};
  `,
);

export const TextAreaWrapper = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s4};
  `,
);

export const CharacterCount = styled.div<{ $isOverLimit: boolean }>(
  ({ theme, $isOverLimit }) => css`
    ${theme.typography.paragraph.s};
    color: ${$isOverLimit ? theme.co.error50 : theme.co.neutral50};
    margin-top: ${theme.sz.s1};
    text-align: right;
  `,
);

export const ErrorMessage = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.error50};
    margin-bottom: ${theme.sz.s4};
    padding: ${theme.sz.s2};
    background-color: ${theme.co.error95};
    border: 1px solid ${theme.co.error90};
    border-radius: ${theme.sz.s1};
  `,
);

export const ButtonsWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.sz.s3};
    justify-content: flex-end;
  `,
);
